
import React from 'react';
import NavBar from '@/components/layout/NavBar';
import Footer from '@/components/layout/Footer';
import FadeInSection from '@/components/ui/FadeInSection';
import IntroSection from '@/components/comparison/IntroSection';
import ComparisonTable from '@/components/comparison/ComparisonTable';
import WhyChooseKeystle from '@/components/comparison/WhyChooseKeystle';
import BottomLineSection from '@/components/comparison/BottomLineSection';
import { useLanguage } from '@/components/i18n/language-provider';

const Comparison = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-7xl">
          <IntroSection />

          <FadeInSection delay={200}>
            <h2 className="text-3xl font-bold mb-8 text-center">
              {t('Feature Comparison')}
            </h2>
            
            <ComparisonTable />
          </FadeInSection>
          
          <FadeInSection delay={300}>
            <WhyChooseKeystle />
          </FadeInSection>
          
          <BottomLineSection />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Comparison;
